import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_monitoring_disclaimer = _resolveComponent("monitoring-disclaimer")!
  const _component_flagged_client_posts_toolbar = _resolveComponent("flagged-client-posts-toolbar")!
  const _component_posts_view_options = _resolveComponent("posts-view-options")!
  const _component_post = _resolveComponent("post")!
  const _component_posts_grid = _resolveComponent("posts-grid")!
  const _component_posts = _resolveComponent("posts")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_monitoring_disclaimer, { class: "q-my-md" }),
    _createVNode(_component_flagged_client_posts_toolbar, {
      client: _ctx.client,
      filters: _ctx.filters,
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters) = $event))
    }, null, 8, ["client", "filters"]),
    _createVNode(_component_posts_view_options, {
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
      "pagination-mode": _ctx.paginationMode,
      "onUpdate:paginationMode": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paginationMode) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_flagged_client_posts_toolbar, {
          client: _ctx.client,
          filters: _ctx.filters,
          "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event)),
          "maximize-btn": { flat: true },
          minimized: ""
        }, null, 8, ["client", "filters"])
      ]),
      _: 1
    }, 8, ["filters", "pagination-mode"]),
    (_ctx.filters.socialSiteIds.length)
      ? (_openBlock(), _createBlock(_component_posts, {
          key: 0,
          filters: _ctx.filters,
          persist: _ctx.paginationMode === 'scroll',
          "infinite-scroll": _ctx.paginationMode === 'scroll',
          "new-page-top": _ctx.paginationMode === 'manual',
          "highlight-flagged-words": ""
        }, {
          default: _withCtx(({ visiblePosts }) => [
            _createVNode(_component_posts_grid, { posts: visiblePosts }, {
              default: _withCtx((post) => [
                _createVNode(_component_post, {
                  post: post,
                  highlight: _ctx.getHighlightRules(post),
                  notes: "",
                  trash: "",
                  actions: "",
                  scrollable: ""
                }, null, 8, ["post", "highlight"])
              ]),
              _: 2
            }, 1032, ["posts"])
          ]),
          _: 1
        }, 8, ["filters", "persist", "infinite-scroll", "new-page-top"]))
      : _createCommentVNode("", true)
  ]))
}